'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024156 from "./presto.types$$anon$156.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Email-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
  this.cdp = null;
  this.cdh = null;
  this.cdi = false;
  this.cdq = null;
  this.cdr = false;
  this.cdu = null;
  this.cdn = null;
  this.cdo = false;
  this.cdj = null;
  this.cdk = false;
  this.cdl = null;
  this.cdm = false;
  this.cds = false;
  this.cdt = false;
  this.cdp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cdu = "TwoFactorAuthEmailPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.cdp;
});
$p.M = (function() {
  if ((!this.cdi)) {
    this.cdh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cdi = true;
  }
  return this.cdh;
});
$p.O = (function() {
  if ((!this.cdr)) {
    this.cdq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cdr = true;
  }
  return this.cdq;
});
$p.D = (function() {
  return this.cdu;
});
$p.t = (function() {
  if ((!this.cdo)) {
    this.cdn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cdo = true;
  }
  return this.cdn;
});
$p.N = (function() {
  if ((!this.cdk)) {
    this.cdj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cdk = true;
  }
  return this.cdj;
});
$p.Q = (function() {
  if ((!this.cdm)) {
    this.cdl = new $j_presto$002etypes$0024$0024anon$0024156.$c_Lpresto_types$$anon$156();
    this.cdm = true;
  }
  return this.cdl;
});
$p.v = (function() {
  if ((!this.cdt)) {
    this.cds = false;
    this.cdt = true;
  }
  return this.cds;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee167) => ((p) => \u03b4scrutinee167.cHC(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthEmailPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$155, "presto.types$TwoFactorAuthPayload$$anon$155", ({
  a2v: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$155.js.map
